module.exports = __webpack_public_path__ + "img/7.9e0a69da.jpg";